import { cn as s } from "../../utils/utils.js";
import { Input as u } from "./input.js";
import { Label as x } from "./label.js";
import { jsx as l, jsxs as n } from "react/jsx-runtime";
import { cva as d } from "class-variance-authority";
var h = d("absolute top-5.5 z-2 origin-[0] -translate-y-4 scale-100 transform truncate text-[16px] duration-300 peer-placeholder-shown:top-4.5 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:text-[14px] peer-autofill:top-5.5 peer-autofill:-translate-y-4 peer-autofill:scale-100 peer-autofill:text-[14px] peer-focus:top-5.5 peer-focus:-translate-y-4 peer-focus:text-[14px] peer-[:not(:placeholder-shown)]:text-[14px] sm:peer-placeholder-shown:text-[16px] sm:peer-autofill:text-[14px] sm:peer-focus:text-[14px]", {
  variants: {
    variant: {
      default: "text-secondary-700 peer-focus:text-primary-700",
      highlight: "text-info-700 peer-focus:text-info-700",
      invalid: "text-error-700 peer-focus:text-error-700",
      disabled: "peer-disabled:text-secondary-500"
    },
    iconPosition: {
      default: "start-4",
      start: "start-2"
    }
  },
  defaultVariants: { variant: "default" }
}), b = d("relative box-border flex h-14 w-full flex-row items-center justify-start rounded-sm border-1 p-0 text-base peer-focus-visible:border-red-800", {
  variants: { variant: {
    default: "border-secondary-700 bg-white text-gray-900 focus-within:border-primary-800",
    highlight: "border-secondary-700 bg-white text-gray-900",
    invalid: "border-error-400 bg-error-100 text-error-700",
    disabled: "border-secondary-400 bg-secondary-100 text-secondary-600"
  } },
  defaultVariants: { variant: "default" }
}), f = d("flex items-center justify-center ps-4 [&_*]:stroke-[1.5] [&_svg]:h-6 [&_svg]:min-h-6 [&_svg]:w-6 [&_svg]:min-w-6", {
  variants: { variant: {
    default: "[&_*]:stroke-primary-800",
    highlight: "[&_*]:stroke-info-600",
    invalid: "[&_*]:stroke-error-400",
    disabled: "[&_*]:stroke-secondary-400"
  } },
  defaultVariants: { variant: "default" }
}), m = ({ className: t, ref: o, variant: r, startIcon: e, endIcon: a, interactiveIcon: p, children: c, ...i }) => /* @__PURE__ */ n("div", {
  className: b({ variant: r }),
  children: [
    e && /* @__PURE__ */ l("span", {
      role: p ? void 0 : "presentation",
      className: s(f({ variant: r }), "ps-4"),
      children: e
    }),
    /* @__PURE__ */ n("div", {
      className: s("relative flex h-full w-full flex-row items-center justify-start gap-0 overflow-hidden rounded-sm bg-transparent"),
      children: [/* @__PURE__ */ l(u, {
        className: s("peer z-2 box-border h-full w-full appearance-none rounded-sm border-0 bg-transparent px-4 pt-6 pb-2 text-base selection:bg-[#b3d4fc] selection:text-secondary-900 placeholder:text-body-2 placeholder:text-secondary-900 focus-visible:ring-0 focus-visible:outline-none disabled:text-secondary-600", {
          "ps-4": !e,
          "pe-4": !a,
          "ps-2": e,
          "pe-2": a,
          "pt-2": !c
        }, t),
        ref: o,
        ...i,
        placeholder: i.placeholder == null ? " " : i.placeholder
      }), c]
    }),
    a && /* @__PURE__ */ l("span", {
      role: p ? void 0 : "presentation",
      className: s(f({ variant: r }), "pe-4"),
      children: a
    })
  ]
}), v = ({ className: t, ref: o, variant: r, iconPosition: e, ...a }) => /* @__PURE__ */ l(x, {
  className: s(h({
    variant: r,
    iconPosition: e
  }), t),
  ref: o,
  ...a
}), V = ({ id: t, label: o, ref: r, ...e }) => /* @__PURE__ */ n("div", {
  className: "relative",
  children: [/* @__PURE__ */ l(m, {
    ref: r,
    id: t,
    ...e
  }), /* @__PURE__ */ l(v, {
    htmlFor: t,
    children: o
  })]
});
export {
  m as FloatingInput,
  v as FloatingLabel,
  V as FloatingLabelInput
};

//# sourceMappingURL=floating-input.js.map